export default __webpack_public_path__ + "static/media/flat-color.vert.44016d13.glsl";